// import { format } from "date-fns";

// const { createSlice } = require("@reduxjs/toolkit");

// function formatDateDisplay(date, defaultText) {
//   if (!date) return defaultText;
//   return format(date, "yyyy-MM-dd");
// }

// // FOR SETTING THE END DATE OF CURRENT
// let current_end_date = new Date();
// current_end_date.setDate(current_end_date.getDate() - 6);

// // FOR SETTING THE START DATE OF PREVIOUS
// let previous_start_date = new Date();
// previous_start_date.setDate(previous_start_date.getDate() - 13);

// // FOR SETTING THE END DATE OF PREVIOUS
// let previous_end_date = new Date();
// previous_end_date.setDate(previous_end_date.getDate() - 7);

// let second_previous_start_date = new Date();
// second_previous_start_date.setDate(second_previous_start_date.getDate() - 20);

// let second_previous_end_date = new Date();
// second_previous_end_date.setDate(second_previous_end_date.getDate() - 14);

// const initialState = {
//   startDate: formatDateDisplay(current_end_date),
//   endDate: formatDateDisplay(new Date()),
//   prevStartDate: formatDateDisplay(previous_start_date),
//   prevEndDate: formatDateDisplay(previous_end_date),
//   secondPrevStartDate: formatDateDisplay(second_previous_start_date),
//   secondPrevEndDate: formatDateDisplay(second_previous_end_date),

//   // startDate: "",
//   // endDate: "",
//   // prevStartDate: "",
//   // prevEndDate: "",
// };

// const dateSlice = createSlice({
//   name: "dates",
//   initialState,
//   reducers: {
//     setStartDate: (state, action) => {
//       state.startDate = action.payload;
//     },
//     setEndDate: (state, action) => {
//       state.endDate = action.payload;
//     },
//     setPrevStartDate: (state, action) => {
//       state.prevStartDate = action.payload;
//     },
//     setPrevEndDate: (state, action) => {
//       state.prevEndDate = action.payload;
//     },
//     // setPrevEndDate: (state, action) => {
//     //   state.prevEndDate = action.payload;
//     // },
//     setSecondPrevStartDate: (state, action) => {
//       state.secondPrevStartDate = action.payload;
//     },
//     setSecondPrevEndDate: (state, action) => {
//       state.secondPrevEndDate = action.payload;
//     },
//     resetDates: () => initialState
//   },
// });

// export const { setStartDate, setEndDate, setPrevStartDate, setPrevEndDate, setSecondPrevStartDate, setSecondPrevEndDate, resetDates } =
//   dateSlice.actions;

// export default dateSlice.reducer;


import { format } from "date-fns";
const { createSlice } = require("@reduxjs/toolkit");

function formatDateDisplay(date, defaultText) {
  if (!date) return defaultText;
  return format(date, "yyyy-MM-dd");
}

// FOR SETTING THE END DATE OF CURRENT
let current_end_date = new Date();
current_end_date.setDate(current_end_date.getDate() - 6);

// FOR SETTING THE START DATE OF PREVIOUS
let previous_start_date = new Date();
previous_start_date.setDate(previous_start_date.getDate() - 13);

// FOR SETTING THE END DATE OF PREVIOUS
let previous_end_date = new Date();
previous_end_date.setDate(previous_end_date.getDate() - 7);

let second_previous_start_date = new Date();
second_previous_start_date.setDate(second_previous_start_date.getDate() - 20);

let second_previous_end_date = new Date();
second_previous_end_date.setDate(second_previous_end_date.getDate() - 14);

// const initialState = {
//   startDate: formatDateDisplay(current_end_date),
//   endDate: formatDateDisplay(new Date()),
//   prevStartDate: formatDateDisplay(previous_start_date),
//   prevEndDate: formatDateDisplay(previous_end_date),
//   secondPrevStartDate: formatDateDisplay(second_previous_start_date),
//   secondPrevEndDate: formatDateDisplay(second_previous_end_date),
// };

const initialState = {
  startDate: "2023-01-01",
  endDate: "2023-12-31",
  prevStartDate: "2022-01-01",
  prevEndDate: "2022-12-31",
  secondPrevStartDate: "2021-01-01",
  secondPrevEndDate: "2021-12-31",
};

const dateSlice = createSlice({
  name: "dates",
  initialState,
  reducers: {
    setStartDate: (state, action) => { state.startDate = action.payload; },
    setEndDate: (state, action) => { state.endDate = action.payload; },
    setPrevStartDate: (state, action) => { state.prevStartDate = action.payload; },
    setPrevEndDate: (state, action) => { state.prevEndDate = action.payload; },
    setSecondPrevStartDate: (state, action) => { state.secondPrevStartDate = action.payload; },
    setSecondPrevEndDate: (state, action) => { state.secondPrevEndDate = action.payload; },
    resetDates: () => initialState
  },
});

export const {
  setStartDate,
  setEndDate,
  setPrevStartDate,
  setPrevEndDate,
  setSecondPrevStartDate,
  setSecondPrevEndDate,
  resetDates
} = dateSlice.actions;

export default dateSlice.reducer;